import { RestClient } from '../lib/RestClient'

class TurmaService extends RestClient {
  constructor() {
    super('turma')
  }

  /**
   * Retorna as turmas de um professor
   * @param {String|number} idProfessor
   * @param {Object} params
   */
  async getPorProfessor(idProfessor, params = {}) {
    const response = await this.request.get(`professor/${idProfessor}`, {
      params
    })
    return response.data
  }
}

export const Turma = new TurmaService()
